import React from 'react';

import {Helmet} from "react-helmet";

import './stylesheets/about.scss';

function About() {
	return (
	<div id="About">
		<Helmet>
			<title>Lor Bookcase - About</title>
		 </Helmet>
		<h1>Created and Maintained by JackTVN</h1>
		<div>
			say hi to me on discord or sth I don't even know if this page will even be used or not
		</div>
		<div>
			oh its JackTran#8895 btw
		</div>
	</div>
	);
}

export default About;